// extracted by mini-css-extract-plugin
export default {"nopadding":"SubNaviFooter_nopadding__GZyqV","footernav":"SubNaviFooter_footernav__FY3ix","nomargin":"SubNaviFooter_nomargin__eR8j0"};